import { IconButton, Popover, Stack, styled, createTheme } from '@mui/material';
import { colors } from '@watter/shared-components';

const cstTheme = createTheme();
export const HeaderStyles = styled(Stack)(({ theme }) => ({
    '& .MuiToggleButtonGroup-root': {
        borderRadius: theme.spacing(12.5),
        overflow: 'hidden',
        alignItems: 'center',
        background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightGray,
        padding: theme.spacing(1),
        columnGap: theme.spacing(1),
        '& .MuiButtonBase-root': {
            borderRadius: '50%',
            padding: theme.spacing(0.5),
            width: theme.spacing(3.25),
            height: theme.spacing(3.25),
            border: 'none',
            '&.Mui-selected': {
                background: theme.palette.mode === 'dark' ? colors.blackColor : colors.white,
            },
            '& svg': {
                width: theme.spacing(2.25),
            },
        },
    },
    '& .MuiIconButton-root': {
        background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightGray,
        color: theme.palette.mode === 'dark' ? colors.info : colors.gray,
        width: theme.spacing(5),
        '& svg': {
            width: theme.spacing(2.25),
        },
    },
    '& .MuiAvatar-root': {
        fontSize: theme.spacing(1.75),
    },
    '& .cstBadge': {
        '& .MuiBadge-badge': {
            background: colors.errorTextBtn,
            fontWeight: 700,
            border: `1px solid ${theme.palette.mode === 'dark' ? colors.blackColor : colors.white}`,
            color: colors.white,
            width: theme.spacing(1.5),
            height: theme.spacing(1.5),
            borderRadius: '50%',
        },
    },
    '& .cstBtnWrapper': {
        '& .MuiBox-root': {
            position: 'relative',
            padding: theme.spacing(0.2),
            marginBottom: theme.spacing(1),

            '& .cstBtn': {
                width: '100px',
                height: '30px',
                background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightBgButton,
                padding: theme.spacing(2, 0),
                boxShadow:
                    theme.palette.mode === 'dark'
                        ? '0px 0px 2px 0px #00000005 inset, -6px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040'
                        : '0px 0px 2px 0px #00000005 inset, 0px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040',
                letterSpacing: '1.25px',
            },

            '&:active': {
                background:
                    'linear-gradient(90deg, #2FABE1 0%, #59BDE7 5.13%, #89D1ED 11.85%, #A8DEF1 16.98%, #B3E3F3 19.87%, #FDCC3F 40.5%, #FF8524 61.36%, #E03C23 80.8%, #441212 100%)',
                borderRadius: theme.spacing(4),
            },

            '&:active::after': {
                content: "''",
                background:
                    'linear-gradient(90deg, #2FABE1 0%, #59BDE7 5.13%, #89D1ED 11.85%, #A8DEF1 16.98%, #B3E3F3 19.87%, #FDCC3F 40.5%, #FF8524 61.36%, #E03C23 80.8%, #441212 100%)',
                position: 'absolute',
                width: '100%',
                height: '100%',
                zIndex: -1,
                inset: 0,
                borderRadius: theme.spacing(4),
            },
        },
    },
    '& .listItem': {
        position: 'relative',
        zIndex: 0,
        '& .MuiIconButton-root': {
            display: 'flex',
            width: theme.spacing(4.75),
            height: theme.spacing(4.75),
            background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightBgButton,

            marginBottom: theme.spacing(1),
            position: 'relative',
            '& svg': {
                width: theme.spacing(2.5),
                '& path': {
                    fill: theme.palette.mode === 'dark' ? colors.info : colors.gray,
                },
            },
            '&:active::after': {
                content: "''",
                background:
                    'linear-gradient(90deg, #2FABE1 0%, #59BDE7 5.13%, #89D1ED 11.85%, #A8DEF1 16.98%, #B3E3F3 19.87%, #FDCC3F 40.5%, #FF8524 61.36%, #E03C23 80.8%, #441212 100%)',
                width: cstTheme.spacing(5.25),
                height: cstTheme.spacing(5.25),
                position: 'absolute',
                borderRadius: '50%',
                zIndex: -1,
            },
        },
        [theme.breakpoints.down('lg')]: {
            justifyContent: 'flex-start',
            '& .MuiIconButton-root': {
                marginBottom: theme.spacing(0),
            },
        },
    },
}));
export const AddWorkOrder = styled(IconButton)(({ theme }) => ({
    background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightGray,
    '&:hover': {
        background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightGray,
    },
    '& .MuiSvgIcon-root': {
        fontSize: theme.spacing(2.25),
        color: theme.palette.mode === 'dark' ? colors.info : colors.gray,
    },
}));

export const AddAdmin = styled(IconButton)(({ theme }) => ({
    background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightGray,
    '&:hover': {
        background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightGray,
    },
    '& .MuiSvgIcon-root': {
        fontSize: theme.spacing(2.25),
        color: theme.palette.mode === 'dark' ? colors.info : colors.gray,
    },
}));

export const ListWrapper = styled(Popover)(({ theme }) => ({
    marginTop: theme.spacing(1),
    borderRadius: theme.spacing(1),
    '& .MuiPaper-root': {
        width: theme.spacing(47.5),
        left: 'auto !important',
        right: theme.spacing(3),
        top: `${theme.spacing(7.75)} !important`,
        border: `1px solid ${theme.palette.mode === 'dark' ? colors.lightHead : colors.lightGray}`,
        [theme.breakpoints.down('sm')]: {
            width: '90%',
        },
        '& .container': {
            background: theme.palette.mode === 'dark' ? colors.blackColor : colors.white,
            '& .cards': {
                background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.whiteSmoke,
                borderRadius: theme.spacing(1),
                '& .unread': {
                    width: theme.spacing(1.75),
                    height: theme.spacing(1.75),
                    borderRadius: '50%',
                    background: colors.verifyText,
                },
                '& .subText': {
                    color: theme.palette.mode === 'dark' ? colors.info : colors.lightHead,
                },
            },
            '& .MuiButton-text': {
                '& .MuiTypography-root': {
                    color: theme.palette.mode === 'dark' ? colors.info : colors.lightHead,
                    textTransform: 'initial',
                },
            },
        },
    },
}));
